import { component, Component, property } from '../../concepts/objects';
import { Rect } from '../../platform/geom/Rect';

@component({ name: 'CameraStartingPosition' })
export class CameraStartingPosition extends Component {

    @property({ type: 'number' })
    public x: number;

    @property({ type: 'number' })
    public y: number;

    @property({ type: 'number' })
    public width: number;

    @property({ type: 'number' })
    public height: number;

    public toRect() {
        return new Rect(this.x, this.y, this.width, this.height);
    }
}
